module.exports = __webpack_public_path__ + "static/media/1.4acb195f.png";